import axiosInstance from "@/services/https/global";
import axios from "axios";
import CONFIG from "@/config";
const authUrl = `${CONFIG.API_BASE_URL}/auth-service/api/v1`;

export const resetPassword = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${authUrl}/password/forgot-password`,
      data,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const forgotPassword = async ({ email }) => {
  try {
    const response = await axiosInstance.get(
      `${authUrl}/password/forgot-password/byEmail`,
      {
        params: { email },
      },
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const logoutUser = async () => {
  try {
    const response = await axiosInstance.post(`${authUrl}/auth/logout`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const refreshAccessToken = async () => {
  try {
    const response = await axiosInstance.post(
      `${authUrl}/auth/refresh-token`,
      {},
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("Refresh token failed");
  }
};

export const login = async (data) => {
  try {
    const response = await axiosInstance.post(`${authUrl}/auth/login`, data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const authOTP = async (email) => {
  try {
    const response = await axiosInstance.post(
      `${authUrl}/auth/generate-login-otp/${email}`,
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const resendOtpRequest = async ({ email }) => {
  try {
    const response = await axiosInstance.post(`${authUrl}/auth/request-otp`, {
      email,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};
